<template>
    <ul class="firmContainer">
        <li class="firmItem" v-for="(firmItem, idx) in firmList" :key="idx">
            <div class="title">{{ firmItem.title }}</div>
            <div class="text">{{ firmItem.text }}</div>

        </li>
    </ul>
</template>

<script>
import timeIcon from "@/assets/img/jinju-2024/icon/icon_time@2x.png"


export default {
    data() {
        return {
            timeIcon,
            firmList: [
                { title: "金发科技-高质量发展上市公司奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "白云机场-高质量发展上市公司奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "恒哲投资", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "天津银行-最佳普惠金融服务", text: "作为东莞金融标杆企业，东莞农商银行始终秉承“奉献社会”的企业使命，“为普惠金融创造最大价值”的核心价值观，“相伴、相信、相成长" },
                { title: "易方达", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "前海人寿-家庭财富首选保险产品奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "平安信托-最佳风控金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "微众银行-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "东莞农商银行-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "科大讯飞-最佳金融科技服务", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "华贵人寿-年度价值创新金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "众邦银行-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "萨摩耶-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "平安证券-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "诺安基金-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "马上消费金融-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "大成基金-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "平安普惠-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "广州基金-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "维信金科-最佳风控金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "百年人寿-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "广东华兴银行-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "哈尔滨银行-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "乐山商行-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "火链科技-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "滴滴金融-最佳应用场景奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "银华基金-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "中信保诚人寿-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "华泰保险-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "平安租赁-最佳风控金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "渤海银行-最佳风控金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "同盾科技-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "恒天财富-最佳财富管理机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "天安人寿-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "雪松国际信托-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "信也科技集团-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "国泰君安-专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "平安人寿-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "天眼查-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "陆金所-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "上海银行-年度社会责任金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "汇添富-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "宁波银行-最佳财富管理机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "富国基金-年度专业服务金融机构", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "兴证全球基金", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

                { title: "易鑫集团-最佳应用场景奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },
                { title: "极融-科技赋能金融机构奖", text: "2020年，平安信托积极响应行业转型号召，全力打造资产数字化全流程投资平台，为信托资产业务提供线上化、移动化、自动化、智能化的" },

            ],
        }
    }
}
</script>

<style lang="scss" scoped>
.firmContainer {
    display: grid;
    gap: 10px 60px;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 20px;
    flex-wrap: wrap;
    margin-top: 61px;

    .firmItem {
        display: flex;
        flex-direction: column;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        margin-bottom: 22px;

        .title {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 24px;
            margin-bottom: 10px;
        }

        .text {
            font-family: Source Han Sans CN;
            font-weight: 300;
            font-size: 13px;
            color: #FFFFFF;
            line-height: 19px;
            opacity: 0.7;
        }
    }
}
</style>
